import { type OperationResponse } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils.ts";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

interface OperationMethods {
  "createVouchers"(
    parameters: Paths.CreateVouchers.PathParameters,
    data?: Paths.CreateVouchers.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.CreateVouchers.Responses.$200>;

  "generateVouchers"(
    parameters: Paths.GenerateVouchers.PathParameters,
    data?: Paths.GenerateVouchers.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GenerateVouchers.Responses.$200>;

  "exportVouchers"(
    parameters: Paths.ExportVouchers.PathParameters,
    data?: any,
    config?: AxiosRequestConfig,
  ): OperationResponse<null>;
}

export const getVoucherSerieOperations = (client: AxiosInstance) => {
  const createVouchers: OperationMethods["createVouchers"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/voucher-serie/{id}/tab/vouchers/create";
    return client.put(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  const generateVouchers: OperationMethods["generateVouchers"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/voucher-serie/{id}/tab/vouchers/generate";
    return client.put(replacePathParameters(url, parameters), data, {
      params: omitPathParameters(parameters, url),
      ...config,
    });
  };

  const exportVouchers: OperationMethods["exportVouchers"] = (
    parameters,
    data,
    config,
  ) => {
    const url = "/voucher-serie/{id}/tab/vouchers/export";
    return client.get(replacePathParameters(url, parameters), {
      params: omitPathParameters(parameters, url),
      data: data,
      ...config,
    });
  };

  return {
    createVouchers,
    exportVouchers,
    generateVouchers,
  };
};
